import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'changeAorderStatus'
})
export class ChangeAorderStatusPipe implements PipeTransform {

  transform(value: string, ...args: string[]): string {
    return value ? 'Nuevo' : 'Aceptado';
    
  }

}
